import React from "react";
import { useHistory, useLocation } from "react-router";
import { resetForgotPassword } from "../../APIs/PostAPIS";
import DashboardFooter from "../Dashboard/DashboardFooter/DashboardFooter";
import LandingHeader from "../LandingPage/LandingHeader/LandingHeader";
import Notification from "../Portals/Notification/Notification";
import "./forgot-password-section.style.scss";
function useQuery() {
  return new URLSearchParams(useLocation().search);
}
export default function ForgotPasswordSection() {
  const history = useHistory();
  let query = useQuery();
  const [error, setError] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [displayPassword, setDisplayPassword] = React.useState(false);
  const [notification, setNotification] = React.useState({
    status: false,
    title: "",
    moreDetails: "",
  });

  const [handleDetails, setHandleDetails] = React.useState({
    password: "",
    cPassword: "",
  });
  const checkError = () => {
    if (
      handleDetails.password &&
      handleDetails.cPassword !== handleDetails.password
    ) {
      return true;
    } else {
      return false;
    }
  };
  const handleSubmit = async () => {
    let token = query.get("token");
    let id = query.get("id");
    setLoading(true);
    try {
      let res = await resetForgotPassword({
        userId: id,
        token: token,
        password: handleDetails.password,
      });
      if (res.data?.data) {
        setNotification({
          status: true,
          title: "Your password is updated",
          moreDetails: "",
        });
        let a = setTimeout(() => {
          history.push("/login");
          clearTimeout(a);
        }, 2000);
      } else {
        setNotification({
          status: true,
          title: res.data.message,
          moreDetails: "",
        });
        let a = setTimeout(() => {
          setNotification({
            status: false,
            title: "",
            moreDetails: "",
          });
          clearTimeout(a);
        }, 2000);
      }
    } catch (error) {
      setLoading(false);
      setNotification({
        status: true,
        title: "Something went wrong",
        moreDetails: "",
      });
      let a = setTimeout(() => {
        setNotification({
          status: false,
          title: "",
          moreDetails: "",
        });
        clearTimeout(a);
      }, 2000);
    }
  };
  return (
    <div className="forgot-password-section">
      <Notification
        enabled={notification.status}
        title={notification.title}
        moreDetails={notification.moreDetails}
        closeIt={() =>
          setNotification({
            status: false,
            title: "",
            moreDetails: "",
          })
        }
      />
      <LandingHeader />
      <section className="reset-password-body">
        <form onSubmit={(e) => e.preventDefault()}>
          <h4>Reset Account Password</h4>

          <div className="on-border-input">
            <span>New password</span>
            <input
              autoComplete="new-password"
              name="password"
              placeholder=""
              type={displayPassword ? "text" : "password"}
              value={handleDetails.password}
              onChange={(e) =>
                setHandleDetails({ ...handleDetails, password: e.target.value })
              }
              required
            />
          </div>
          <div
            className={`on-border-input ${error ? "error-input" : ""} ${
              handleDetails.password &&
              handleDetails.password === handleDetails.cPassword
                ? "correct"
                : ""
            }`}
          >
            <span>Confirm password</span>
            <input
              autoComplete="new-password"
              name="cPassword"
              placeholder=""
              type={displayPassword ? "text" : "password"}
              required
              value={handleDetails.cPassword}
              onChange={(e) => {
                setError(false);
                setHandleDetails({
                  ...handleDetails,
                  cPassword: e.target.value,
                });
              }}
            />
            <p>
              {handleDetails.password &&
              handleDetails.password === handleDetails.cPassword
                ? "Matched"
                : "Unmatched"}{" "}
              Password
            </p>
          </div>
          <div className="check-wrapper">
            <input
              onChange={(e) => setDisplayPassword(e.target.checked)}
              checked={displayPassword}
              type="checkbox"
            />
            <span>Show Password</span>
          </div>
          <div className="submit-button-wrapper">
            <button
              onClick={() => (checkError() ? setError(true) : handleSubmit())}
              className="submit-button"
            >
              {loading ? "Updating...." : "Update"}
            </button>
          </div>
        </form>
      </section>
      <DashboardFooter />
    </div>
  );
}
